export default __webpack_public_path__ + "static/media/mm-icon.5f376da8.png";